module.exports = "images/Rakete_small_2.gif";